

















































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import Datepicker from 'vue2-datepicker';
import i18n from '@/services/i18n';
import i18nDb from '@/services/i18n-db';
import * as common from '../common';
import { CollapsiblePane, ComponentBase, NumberInput, Overlay, Pagination } from '../components';
import type { Comp, Dict, Report, Utils } from '../types';


type SortField = 'ID' | 'FUNC_BLOCK' | 'LEVEL' | 'ACTIVITY_FIELD' | 'ACTIVITY_FIELD_EXCLUSION' | 'BEG_DATE' | 'END_DATE'
    | 'RATE' | 'FORM' | 'FUNC_GR' | 'EDU_HOURS_CODE' | 'EDU_ORG_TYPE_CODE' | 'EAD_CODE' | 'CUR_YEAR' | 'RATE_REMAINDER';

/**
 * Настройки поиска повышающих коэффициентов гражданских должностей
 */
interface DictCivilPositionIncRateSearchConfig {
    /**
     * Количество элементов на странице
     */
    itemsPerPage: number | null;

    /**
     * Индекс страницы, нумерация с `0`
     */
    page: number | null;

    /**
     * Список ID записей
     */
    idSet: Array<number> | null;

    /**
     * Список функциональных блоков
     */
    funcBlockSet: Array<string | null> | null;

    /**
     * Список ID звеньев
     */
    levelSet: Array<number | null> | null;

    /**
     * Список сфер деятельности
     */
    activityFieldSet: Array<string | null> | null;

    /**
     * Список сфера деятельности - исключений
     */
    activityFieldExclusionSet: Array<string | null> | null;

    /**
     * Период "от" (включительно) - начало диапазона
     */
    begDateStartValue: Date | null;

    /**
     * Период "от" (включительно) - конец диапазона
     */
    begDateEndValue: Date | null;

    /**
     * Период "до" (не включительно) - начало диапазона
     */
    endDateStartValue: Date | null;

    /**
     * Период "до" (не включительно) - конец диапазона
     */
    endDateEndValue: Date | null;

    /**
     * Размер повышающего коэффициента к должностному окладу - начало диапазона
     */
    rateStartValue: number | null;

    /**
     * Размер повышающего коэффициента к должностному окладу - конец диапазона
     */
    rateEndValue: number | null;

    /**
     * Список форм расчетов (в формате "F_XX_XXX", где "X" - цифра)
     */
    formSet: Array<string | null> | null;

    /**
     * Список функциональных групп
     */
    funcGrSet: Array<number | null> | null;

    /**
     * Список кодов нормативных часов организаций образования (dict_st_edu_hours.code)
     */
    eduHoursCodeSet: Array<string | null> | null;

    /**
     * Список кодов типов организаций образования
     */
    eduOrgTypeCodeSet: Array<string | null> | null;

    /**
     * Список кодов доп. атрибутов
     */
    eadCodeSet: Array<string | null> | null;

    /**
     * Базовый год - начало диапазона
     */
    curYearStartValue: number | null;

    /**
     * Базовый год - конец диапазона
     */
    curYearEndValue: number | null;

    /**
     * Остаток от поправочного коэффициента - начало диапазона
     */
    rateRemainderStartValue: number | null;

    /**
     * Остаток от поправочного коэффициента - конец диапазона
     */
    rateRemainderEndValue: number | null;

    /**
     * Поле для сортировки
     */
    sortField: SortField | null;

    /**
     * Признак "обратная сортировка" (от большего к меньшему)
     */
    reversedSort: boolean | null;
}


const translates = {
    actions: {
        get add(): string {
            return i18n.choose(
                'Добавить',
                'Қосу',
                'Add',
            );
        },
        get apply(): string {
            return i18n.choose(
                'Применить',
                'Қолдану',
                'Apply',
            );
        },
        get delete(): string {
            return i18n.choose(
                'Удалить',
                'Жою',
                'Delete',
            );
        },
        get edit(): string {
            return i18n.choose(
                'Изменить',
                'Өзгерту',
                'Edit',
            );
        },
        get refresh(): string {
            return i18n.choose(
                'Обновить',
                'Жаңарту',
                'Refresh',
            );
        },
        get save(): string {
            return i18n.choose(
                'Сохранить',
                'Сақтау',
                'Save',
            );
        },
    },
    deletionConfirmationText(id: number): string {
        return i18n.choose(
            () => `Удалить элемент с ID #${id}?`,
            () => `#${id} идентификаторы бар элементті жою керек пе?`,
            () => `Delete element with ID #${id}?`,
        )();
    },
    errors: {
        get cannotDeleteData(): string {
            return i18n.choose(
                'Не удалось удалить данные',
                'Деректерді жою мүмкін болмады',
                'Failed to delete data',
            );
        },
        get cannotLoadData(): string {
            return i18n.choose(
                'Не удалось загрузить данные',
                'Деректерді жүктеу сәтсіз аяқталды',
                'Failed to load data',
            );
        },
        get cannotSaveData(): string {
            return i18n.choose(
                'Не удалось сохранить данные',
                'Деректерді сақтау мүмкін болмады',
                'Failed to save data',
            );
        },
    },
    fields: {
        id: {
            get title(): string {
                return 'ID';
            },
        },
        funcBlock: {
            get title(): string {
                return i18n.choose(
                    'Функциональный блок',
                    'Функционалды блок',
                    'Functional block',
                );
            },
        },
        level: {
            get title(): string {
                return i18n.choose(
                    'ID звена',
                    'Сілтеме идентификаторы',
                    'Level ID',
                );
            },
        },
        activityField: {
            get title(): string {
                return i18n.choose(
                    'Сфера деятельности',
                    'Қызмет саласы',
                    'Field of activity',
                );
            },
        },
        activityFieldExclusion: {
            get title(): string {
                return i18n.choose(
                    'Сфера деятельности - исключение',
                    'Қызмет саласы – ерекшелік',
                    'Field of activity - exception',
                );
            },
        },
        begDate: {
            get title(): string {
                return i18n.choose(
                    'Период: от (включительно)',
                    'Мерзімі: бастап (қоса алғанда)',
                    'Period: from (inclusive)',
                );
            },
        },
        endDate: {
            get title(): string {
                return i18n.choose(
                    'Период: до (не включительно)',
                    'Мерзімі: дейін (қоса есептелмейді)',
                    'Period: up to (not inclusive)',
                );
            },
        },
        rate: {
            get title(): string {
                return i18n.choose(
                    'Размер повышающего коэффициента к должностному окладу',
                    'Лауазымды жалақыға өсу коэффициентінің мөлшері',
                    'The size of the increasing coefficient to the official salary',
                );
            },
        },
        form: {
            get title(): string {
                return i18n.choose(
                    'Форма расчетов (в формате "F_XX_XXX", где "X" - цифра)',
                    'Төлем нысаны ("F_XX_XXX" форматында, мұнда "X" - сан)',
                    'Payment form (in the format "F_XX_XXX", where "X" is a number)',
                );
            },
        },
        funcGr: {
            get title(): string {
                return i18n.choose(
                    'Функциональная группа',
                    'Функционалды топ',
                    'Functional group',
                );
            },
        },
        eduHoursCode: {
            get title(): string {
                return i18n.choose(
                    'Код нормативных часов организации образования',
                    'Білім беру ұйымының үлгі сағаттарының коды',
                    'Code of standard hours of the educational organization',
                );
            },
        },
        eduOrgTypeCode: {
            get title(): string {
                return i18n.choose(
                    'Код типа огранизации образования',
                    'Білім беру ұйымының типінің коды',
                    'Educational organization type code',
                );
            },
        },
        eadCode: {
            get title(): string {
                return i18n.choose(
                    'Код доп. атрибута',
                    'Additional code attribute',
                    'Қосымша код атрибуты',
                );
            },
        },
        curYear: {
            get title(): string {
                return i18n.choose(
                    'Базовый год',
                    'Негізгі жыл',
                    'Base year',
                );
            },
        },
        rateRemainder: {
            get title(): string {
                return i18n.choose(
                    'Остаток от поправочного коэффициента',
                    'Түзету коэффициентінің қалдығы',
                    'Remainder of the correction factor',
                );
            },
        },
    },
    filterSort: {
        get title(): string {
            return i18n.choose(
                'Фильтры, сортировка',
                'Сүзгілер, сұрыптау',
                'Filter, sort',
            );
        },
        filter: {
            get copyToMax(): string {
                return i18n.choose(
                    'Скопировать как максимальное значение',
                    'Максималды мән ретінде көшіріңіз',
                    'Copy as maximal value',
                );
            },
            get maxValue(): string {
                return i18n.choose(
                    'Максимальное значение',
                    'Максималды мән',
                    'Maximal value',
                );
            },
            get minValue(): string {
                return i18n.choose(
                    'Минимальное значение',
                    'Ең төменгі мән',
                    'Minimal value',
                );
            },
            get reset(): string {
                return i18n.choose(
                    'Сбросить фильтры',
                    'Сүзгілерді қалпына келтіру',
                    'Reset filters',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Фильтры',
                    'Сүзгілер',
                    'Filters',
                );
            },
            get valueSet(): string {
                return i18n.choose(
                    'Набор значений',
                    'Мәндер жиыны',
                    'Value set',
                );
            },
            get valueSetByComma(): string {
                return i18n.choose(
                    'Набор значений, разделенных запятыми',
                    'Үтірмен бөлінген мәндер жинағы',
                    'Value set separated by commas',
                );
            },
        },
        sort: {
            get field(): string {
                return i18n.choose(
                    'Поле для сортировки',
                    'Сұрыптауға арналған өріс',
                    'Field for sorting',
                );
            },
            get reversedOrder(): string {
                return i18n.choose(
                    'Сортировать в обратном порядке',
                    'Кері ретпен сұрыптау',
                    'Sort in reverse order',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Сортировка',
                    'Сұрыптау',
                    'Sort',
                );
            },
        },
    },
    messages: {
        dataDeleted(id: number): string {
            return i18n.choose(
                () => `Данные успешно удалены, ID = #${id}`,
                () => `Деректер сәтті жойылды, ID = #${id}`,
                () => `Data deleted successfully, ID = #${id}`,
            )();
        },
        dataSaved(id: number): string {
            return i18n.choose(
                () => `Данные успешно сохранены, ID = #${id}`,
                () => `Деректер сәтті сақталды, ID = #${id}`,
                () => `Data saved successfully, ID = #${id}`,
            )();
        },
    },
};

const newSearchConfig = (): DictCivilPositionIncRateSearchConfig => {
    return {
        itemsPerPage: null,
        page: null,
        idSet: null,
        funcBlockSet: null,
        levelSet: null,
        activityFieldSet: null,
        activityFieldExclusionSet: null,
        begDateStartValue: null,
        begDateEndValue: null,
        endDateStartValue: null,
        endDateEndValue: null,
        rateStartValue: null,
        rateEndValue: null,
        formSet: null,
        funcGrSet: null,
        eduHoursCodeSet: null,
        eduOrgTypeCodeSet: null,
        eadCodeSet: null,
        curYearStartValue: null,
        curYearEndValue: null,
        rateRemainderStartValue: null,
        rateRemainderEndValue: null,
        sortField: null,
        reversedSort: null,
    };
};


@Component({
    components: {
        'date-picker': Datepicker,
        CollapsiblePane,
        NumberInput,
        Overlay,
        Pagination,
    },
})
export default class DictCivilPositionIncRateListPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    created() {
        // region Навигация по страницам
        this.$watch('page', () => {
            this.loadIfIdle();
        });
        this.$watch('itemsPerPage', () => {
            this.loadIfIdle();
        });
        // endregion
    }

    protected mounted() {
        this.loadIfIdle();
    }
    // endregion


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private formatDate(value: Date | null): string | null {
        if (value === null) {
            return null;
        }
        return i18nDb.translateByTemplate(i18nDb.dateTemplateLong(), value);
    }

    private get activityFieldOptions(): Array<Comp.DropdownItemDef<Dict.CivilPosition.ActivityField | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // 'ALL' - Все сферы деятельности
            {
                value: 'ALL',
                text: '"ALL" - Все сферы деятельности',
            },

            // 'EDUCATION' - Образование (со статусом "педагог")
            {
                value: 'EDUCATION',
                text: '"EDUCATION" - Образование (со статусом "педагог")',
            },

            // 'EDUCATION_BEZ_STATUSA' - Образование (без статуса "педагог")
            {
                value: 'EDUCATION_BEZ_STATUSA',
                text: '"EDUCATION_BEZ_STATUSA" - Образование (без статуса "педагог")',
            },

            // 'HEALTH' - Здравоохранение
            {
                value: 'HEALTH',
                text: '"HEALTH" - Здравоохранение',
            },

            // 'HEALTH_AND_EDUCATION' - Здравоохранение; Образование
            {
                value: 'HEALTH_AND_EDUCATION',
                text: '"HEALTH_AND_EDUCATION" - Здравоохранение; Образование',
            },

            // 'ALL_EXCEPT_HEALTH_AND_EDUCATION' - Прочие сферы (кроме здравоохранения и образования)
            {
                value: 'ALL_EXCEPT_HEALTH_AND_EDUCATION',
                text: '"ALL_EXCEPT_HEALTH_AND_EDUCATION" - Прочие сферы (кроме здравоохранения и образования)',
            },

            // 'SPORT' - Спорт
            {
                value: 'SPORT',
                text: '"SPORT" - Спорт',
            },
        ];
    }

    private get fieldOptions(): Array<Comp.DropdownItemDef<SortField | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // ID
            {
                value: 'ID',
                text: translates.fields.id.title,
            },

            // FUNC_BLOCK
            {
                value: 'FUNC_BLOCK',
                text: 'Функциональный блок',
            },

            // LEVEL
            {
                value: 'LEVEL',
                text: translates.fields.level.title,
            },

            // ACTIVITY_FIELD
            {
                value: 'ACTIVITY_FIELD',
                text: translates.fields.activityField.title,
            },

            // ACTIVITY_FIELD_EXCLUSION
            {
                value: 'ACTIVITY_FIELD_EXCLUSION',
                text: translates.fields.activityFieldExclusion.title,
            },

            // BEG_DATE
            {
                value: 'BEG_DATE',
                text: translates.fields.begDate.title,
            },

            // END_DATE
            {
                value: 'END_DATE',
                text: translates.fields.endDate.title,
            },

            // RATE
            {
                value: 'RATE',
                text: translates.fields.rate.title,
            },

            // FORM
            {
                value: 'FORM',
                text: translates.fields.form.title,
            },

            // FUNC_GR
            {
                value: 'FUNC_GR',
                text: translates.fields.funcGr.title,
            },

            // EDU_HOURS_CODE
            {
                value: 'EDU_HOURS_CODE',
                text: translates.fields.eduHoursCode.title,
            },

            // EDU_ORG_TYPE_CODE
            {
                value: 'EDU_ORG_TYPE_CODE',
                text: translates.fields.eduOrgTypeCode.title,
            },

            // EAD_CODE
            {
                value: 'EAD_CODE',
                text: translates.fields.eadCode.title,
            },

            // CUR_YEAR
            {
                value: 'CUR_YEAR',
                text: translates.fields.curYear.title,
            },

            // RATE_REMAINDER
            {
                value: 'RATE_REMAINDER',
                text: translates.fields.rateRemainder.title,
            },
        ];
    }

    private get funcBlockOptions(): Array<Comp.DropdownItemDef<Dict.CivilPosition.FunctionalBlock | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // 'A' - Управленческий персонал
            {
                value: 'A',
                text: '"A" - Управленческий персонал',
            },

            // 'B' - Основной персонал
            {
                value: 'B',
                text: '"B" - Основной персонал',
            },

            // 'C' - Содействующий персонал (административный)
            {
                value: 'C',
                text: '"C" - Содействующий персонал (административный)',
            },

            // 'D' - Вспомогательный персонал
            {
                value: 'D',
                text: '"D" - Вспомогательный персонал',
            },
        ];
    }

    private get reportFormOptions(): Array<Comp.DropdownItemDef<Report.FormKey | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            { value: 'F_01_111', text: 'F_01_111' },
            { value: 'F_02_111', text: 'F_02_111' },
            { value: 'F_04_111', text: 'F_04_111' },
            { value: 'F_05_111', text: 'F_05_111' },
            { value: 'F_06_111', text: 'F_06_111' },
            { value: 'F_07_111', text: 'F_07_111' },
            { value: 'F_08_111', text: 'F_08_111' },
            { value: 'F_09_111', text: 'F_09_111' },
            { value: 'F_10_111', text: 'F_10_111' },
            { value: 'F_11_111', text: 'F_11_111' },
            { value: 'F_13_111', text: 'F_13_111' },

            { value: 'F_01_131', text: 'F_01_131' },
            { value: 'F_02_131', text: 'F_02_131' },
        ];
    }
    // endregion


    // region Навигация по страницам
    private page = 0;
    private itemsPerPage = 25;
    private totalItems = 0;

    private onItemsPerPageChanged(itemsPerPage: unknown): void {
        this.itemsPerPage = (itemsPerPage as number);
    }
    // endregion


    // region Загрузка, общее
    private loading = false;
    private loadingId: symbol | null = null;
    // endregion


    // region Элементы, фильтрация, сортировка
    // noinspection JSMismatchedCollectionQueryUpdate
    private items: Array<Dict.CivilPositionIncRate> = [];

    private filterSortModalVisible = false;
    private filterSortFilterPaneExpanded = false;
    private filterSortSortPaneExpanded = false;

    private filterIdSet: Set<number> = new Set();
    private filterIdSetInput: string = '';
    private filterFuncBlockSet: Set<string | null> = new Set();
    private filterFuncBlockSetInput: Set<string | null> = new Set();
    private filterLevelSet: Set<number | null> = new Set();
    private filterLevelSetInput: string = '';
    private filterActivityFieldSet: Set<string | null> = new Set();
    private filterActivityFieldSetInput: Set<string | null> = new Set();
    private filterActivityFieldExclusionSet: Set<string | null> = new Set();
    private filterActivityFieldExclusionSetInput: Set<string | null> = new Set();
    private filterBegDateStartValue: Date | null = null;
    private filterBegDateStartValueInput: Date | null = null;
    private filterBegDateEndValue: Date | null = null;
    private filterBegDateEndValueInput: Date | null = null;
    private filterEndDateStartValue: Date | null = null;
    private filterEndDateStartValueInput: Date | null = null;
    private filterEndDateEndValue: Date | null = null;
    private filterEndDateEndValueInput: Date | null = null;
    private filterRateStartValue: number | null = null;
    private filterRateStartValueInput: number | null = null;
    private filterRateEndValue: number | null = null;
    private filterRateEndValueInput: number | null = null;
    private filterFormSet: Set<string | null> = new Set();
    private filterFormSetInput: Set<string | null> = new Set();
    private filterFuncGrSet: Set<number | null> = new Set();
    private filterFuncGrSetInput: string = '';
    private filterEduHoursCodeSet: Set<string | null> = new Set();
    private filterEduHoursCodeSetInput: string = '';
    private filterEduOrgTypeCodeSet: Set<string | null> = new Set();
    private filterEduOrgTypeCodeSetInput: string = '';
    private filterEadCodeSet: Set<string | null> = new Set();
    private filterEadCodeSetInput: string = '';
    private filterCurYearStartValue: number | null = null;
    private filterCurYearStartValueInput: number | null = null;
    private filterCurYearEndValue: number | null = null;
    private filterCurYearEndValueInput: number | null = null;
    private filterRateRemainderStartValue: number | null = null;
    private filterRateRemainderStartValueInput: number | null = null;
    private filterRateRemainderEndValue: number | null = null;
    private filterRateRemainderEndValueInput: number | null = null;

    private sortField: SortField | null = 'ID';
    private tmpSortField: SortField | null = null;
    private reversedSort = false;
    private tmpReversedSort = false;

    private get filterIdSetParsed(): Array<number> {
        return this.filterIdSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }

    private get filterLevelSetParsed(): Array<number | null> {
        return this.filterLevelSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }

    private get filterFuncGrSetParsed(): Array<number | null> {
        return this.filterFuncGrSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }

    private get filterEduHoursCodeSetParsed(): Array<string | null> {
        return this.filterEduHoursCodeSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }

    private get filterEduOrgTypeCodeSetParsed(): Array<string | null> {
        return this.filterEduOrgTypeCodeSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }

    private get filterEadCodeSetParsed(): Array<string | null> {
        return this.filterEadCodeSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }


    private changeFilterSort() {
        this.filterIdSetInput = [...this.filterIdSet].join(', ');
        this.filterFuncBlockSetInput = new Set(this.filterFuncBlockSet);
        this.filterLevelSetInput = [...this.filterLevelSet].join(', ');
        this.filterActivityFieldSetInput = new Set(this.filterActivityFieldSet);
        this.filterActivityFieldExclusionSetInput = new Set(this.filterActivityFieldExclusionSet);
        this.filterBegDateStartValueInput = this.filterBegDateStartValue;
        this.filterBegDateEndValueInput = this.filterBegDateEndValue;
        this.filterEndDateStartValueInput = this.filterEndDateStartValue;
        this.filterEndDateEndValueInput = this.filterEndDateEndValue;
        this.filterRateStartValueInput = this.filterRateStartValue;
        this.filterRateEndValueInput = this.filterRateEndValue;
        this.filterFormSetInput = new Set(this.filterFormSet);
        this.filterFuncGrSetInput = [...this.filterFuncGrSet].join(', ');
        this.filterEduHoursCodeSetInput = [...this.filterEduHoursCodeSet].join(', ');
        this.filterEduOrgTypeCodeSetInput = [...this.filterEduOrgTypeCodeSet].join(', ');
        this.filterEadCodeSetInput = [...this.filterEadCodeSet].join(', ');
        this.filterCurYearStartValueInput = this.filterCurYearStartValue;
        this.filterCurYearEndValueInput = this.filterCurYearEndValue;
        this.filterRateRemainderStartValueInput = this.filterRateRemainderStartValue;
        this.filterRateRemainderEndValueInput = this.filterRateRemainderEndValue;

        this.tmpSortField = this.sortField;
        this.tmpReversedSort = this.reversedSort;
        this.filterSortModalVisible = true;
    }

    private resetFilter() {
        this.filterIdSetInput = '';
        this.filterFuncBlockSetInput = new Set();
        this.filterLevelSetInput = '';
        this.filterActivityFieldSetInput = new Set();
        this.filterActivityFieldExclusionSetInput = new Set();
        this.filterBegDateStartValueInput = null;
        this.filterBegDateEndValueInput = null;
        this.filterEndDateStartValueInput = null;
        this.filterEndDateEndValueInput = null;
        this.filterRateStartValueInput = null;
        this.filterRateEndValueInput = null;
        this.filterFormSetInput = new Set();
        this.filterFuncGrSetInput = '';
        this.filterEduHoursCodeSetInput = '';
        this.filterEduOrgTypeCodeSetInput = '';
        this.filterEadCodeSetInput = '';
        this.filterCurYearStartValueInput = null;
        this.filterCurYearEndValueInput = null;
        this.filterRateRemainderStartValueInput = null;
        this.filterRateRemainderEndValueInput = null;
    }

    private applyFilterSort() {
        this.filterIdSet = new Set(this.filterIdSetParsed);
        this.filterFuncBlockSet = new Set(this.filterFuncBlockSetInput);
        this.filterLevelSet = new Set(this.filterLevelSetParsed);
        this.filterActivityFieldSet = new Set(this.filterActivityFieldSetInput);
        this.filterActivityFieldExclusionSet = new Set(this.filterActivityFieldExclusionSetInput);
        this.filterBegDateStartValue = this.filterBegDateStartValueInput;
        this.filterBegDateEndValue = this.filterBegDateEndValueInput;
        this.filterEndDateStartValue = this.filterEndDateStartValueInput;
        this.filterEndDateEndValue = this.filterEndDateEndValueInput;
        this.filterRateStartValue = this.filterRateStartValueInput;
        this.filterRateEndValue = this.filterRateEndValueInput;
        this.filterFormSet = new Set(this.filterFormSetInput);
        this.filterFuncGrSet = new Set(this.filterFuncGrSetParsed);
        this.filterEduHoursCodeSet = new Set(this.filterEduHoursCodeSetParsed);
        this.filterEduOrgTypeCodeSet = new Set(this.filterEduOrgTypeCodeSetParsed);
        this.filterEadCodeSet = new Set(this.filterEadCodeSetParsed);
        this.filterCurYearStartValue = this.filterCurYearStartValueInput;
        this.filterCurYearEndValue = this.filterCurYearEndValueInput;
        this.filterRateRemainderStartValue = this.filterRateRemainderStartValueInput;
        this.filterRateRemainderEndValue = this.filterRateRemainderEndValueInput;

        this.sortField = this.tmpSortField;
        this.reversedSort = this.tmpReversedSort;
        this.loadIfIdle();
    }

    private toggleFilterFuncBlock(value: string) {
        const set = new Set(this.filterFuncBlockSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterFuncBlockSetInput = set;
    }

    private toggleFilterActivityField(value: string) {
        const set = new Set(this.filterActivityFieldSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterActivityFieldSetInput = set;
    }

    private toggleFilterActivityFieldExclusion(value: string) {
        const set = new Set(this.filterActivityFieldExclusionSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterActivityFieldExclusionSetInput = set;
    }

    private toggleFilterForm(value: string) {
        const set = new Set(this.filterFormSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterFormSetInput = set;
    }

    private loadIfIdle() {
        if (!this.loading) {
            this.load();
        }
    }

    private load() {
        if (this.loading) {
            console.error('Cannot load data - loading already in progress');
            return;
        }

        const searchConfig = newSearchConfig();
        searchConfig.itemsPerPage = this.itemsPerPage;
        searchConfig.page = this.page;
        searchConfig.sortField = this.sortField;
        searchConfig.reversedSort = this.reversedSort;

        if (this.filterIdSet.size > 0) {
            searchConfig.idSet = [...this.filterIdSet];
        }
        if (this.filterFuncBlockSet.size > 0) {
            searchConfig.funcBlockSet = [...this.filterFuncBlockSet];
        }
        if (this.filterLevelSet.size > 0) {
            searchConfig.levelSet = [...this.filterLevelSet];
        }
        if (this.filterActivityFieldSet.size > 0) {
            searchConfig.activityFieldSet = [...this.filterActivityFieldSet];
        }
        if (this.filterActivityFieldExclusionSet.size > 0) {
            searchConfig.activityFieldExclusionSet = [...this.filterActivityFieldExclusionSet];
        }
        if (this.filterBegDateStartValue != null) {
            searchConfig.begDateStartValue = common.convertToKotlinLocalDate(this.filterBegDateStartValue) as unknown as Date;
        }
        if (this.filterBegDateEndValue != null) {
            searchConfig.begDateEndValue = common.convertToKotlinLocalDate(this.filterBegDateEndValue) as unknown as Date;
        }
        if (this.filterEndDateStartValue != null) {
            searchConfig.endDateStartValue = common.convertToKotlinLocalDate(this.filterEndDateStartValue) as unknown as Date;
        }
        if (this.filterEndDateEndValue != null) {
            searchConfig.endDateEndValue = common.convertToKotlinLocalDate(this.filterEndDateEndValue) as unknown as Date;
        }
        if (this.filterRateStartValue != null) {
            searchConfig.rateStartValue = this.filterRateStartValue;
        }
        if (this.filterRateEndValue != null) {
            searchConfig.rateEndValue = this.filterRateEndValue;
        }
        if (this.filterFormSet.size > 0) {
            searchConfig.formSet = [...this.filterFormSet];
        }
        if (this.filterFuncGrSet.size > 0) {
            searchConfig.funcGrSet = [...this.filterFuncGrSet];
        }
        if (this.filterEduHoursCodeSet.size > 0) {
            searchConfig.eduHoursCodeSet = [...this.filterEduHoursCodeSet];
        }
        if (this.filterEduOrgTypeCodeSet.size > 0) {
            searchConfig.eduOrgTypeCodeSet = [...this.filterEduOrgTypeCodeSet];
        }
        if (this.filterEadCodeSet.size > 0) {
            searchConfig.eadCodeSet = [...this.filterEadCodeSet];
        }
        if (this.filterCurYearStartValue != null) {
            searchConfig.curYearStartValue = this.filterCurYearStartValue;
        }
        if (this.filterCurYearEndValue != null) {
            searchConfig.curYearEndValue = this.filterCurYearEndValue;
        }
        if (this.filterRateRemainderStartValue != null) {
            searchConfig.rateRemainderStartValue = this.filterRateRemainderStartValue;
        }
        if (this.filterRateRemainderEndValue != null) {
            searchConfig.rateRemainderEndValue = this.filterRateRemainderEndValue;
        }

        const loadingId = Symbol('DictCivilPositionIncRatePage.load');
        this.loading = true;
        this.loadingId = loadingId;
        this.items = [];

        this.request<Utils.PaginationList<Dict.CivilPositionIncRate>>(
            {
                url: '/api/budget/staffing_table/dict/dict_civil_position_inc_rate/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                data.items.forEach((item) => {
                    if (Array.isArray(item.begDate)) {
                        item.begDate = common.convertFromKotlinLocalDate(item.begDate);
                    }
                    if (Array.isArray(item.endDate)) {
                        item.endDate = common.convertFromKotlinLocalDate(item.endDate);
                    }
                });

                this.totalItems = data.itemCount;
                this.page = data.page;
                this.items = data.items;
            },
            () => this.translates.errors.cannotLoadData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.loadingId = null;
                this.loading = false;
            },
        );
    }
    // endregion


    // region Редактируемый элемент
    private elementChangeModalVisible = false;

    /**
     * ID записи
     *
     * `PRIMARY KEY`
     */
    private changedElementId: number | null = null;

    /**
     * Функциональный блок:
     * - "A" - управленческий персонал;
     * - "B" - основной персонал;
     * - "C" - содействующий персонал (административный);
     * - "D" - вспомогательный персонал.
     */
    private changedElementFuncBlock: Dict.CivilPosition.FunctionalBlock | null = null;

    /**
     * ID звена
     *
     * `REFERENCES public.dict_civil_position_level (id)`
     */
    private changedElementLevel: number | null = null;

    /**
     * Сфера деятельности:
     * - "ALL" - все сферы;
     * - "EDUCATION" - образование;
     * - "HEALTH" - здравоохранение;
     * - "ALL_EXCEPT_HEALTH_AND_EDUCATION" - прочие сферы (кроме Здравоохранения; Образования).
     */
    private changedElementActivityField: Dict.CivilPosition.ActivityField | null = null;

    /**
     * Сфера деятельности - исключение:
     * - "ALL" - все сферы;
     * - "EDUCATION" - образование;
     * - "HEALTH" - здравоохранение;
     * - "ALL_EXCEPT_HEALTH_AND_EDUCATION" - прочие сферы (кроме Здравоохранения; Образования).
     */
    private changedElementActivityFieldExclusion: Dict.CivilPosition.ActivityField | null = null;

    /**
     * Период: от (включительно)
     */
    private changedElementBegDate: Date | null = null;

    /**
     * Период: до (не включительно)
     */
    private changedElementEndDate: Date | null = null;

    /**
     * Размер повышающего коэффициента к должностному окладу
     */
    private changedElementRate: number = 0;

    /**
     * Форма расчетов (в формате "F_XX_XXX", где "X" - цифра)
     */
    private changedElementForm: Report.FormKey | null = null;

    /**
     * Функциональная группа
     */
    private changedElementFuncGr: number | null = null;

    /**
     * Код нормативных часов организации образования (dict_st_edu_hours.code)
     */
    private changedElementEduHoursCode: string | null = null;

    /**
     * Код типа огранизации образования
     */
    private changedElementEduOrgTypeCode: string | null = null;

    /**
     * Код доп. атрибута
     */
    private changedElementEadCode: string | null = null;

    /**
     * Базовый год
     */
    private changedElementCurYear: number | null = null;

    /**
     * Остаток от поправочного коэффициента.
     *
     * Для распределения по двум бюдж. программам.
     */
    private changedElementRateRemainder: number | null = null;

    private startElementChange(element?: Dict.CivilPositionIncRate) {
        if (element === undefined) {
            this.changedElementId = null;
            this.changedElementFuncBlock = null;
            this.changedElementLevel = null;
            this.changedElementActivityField = null;
            this.changedElementActivityFieldExclusion = null;
            this.changedElementBegDate = null;
            this.changedElementEndDate = null;
            this.changedElementRate = 0;
            this.changedElementForm = null;
            this.changedElementFuncGr = null;
            this.changedElementEduHoursCode = null;
            this.changedElementEduOrgTypeCode = null;
            this.changedElementEadCode = null;
            this.changedElementCurYear = null;
            this.changedElementRateRemainder = null;
        } else {
            this.changedElementId = element.id;
            this.changedElementFuncBlock = element.funcBlock;
            this.changedElementLevel = element.level;
            this.changedElementActivityField = element.activityField;
            this.changedElementActivityFieldExclusion = element.activityFieldExclusion;
            this.changedElementBegDate = element.begDate;
            this.changedElementEndDate = element.endDate;
            this.changedElementRate = element.rate;
            this.changedElementForm = element.form;
            this.changedElementFuncGr = element.funcGr;
            this.changedElementEduHoursCode = element.eduHoursCode;
            this.changedElementEduOrgTypeCode = element.eduOrgTypeCode;
            this.changedElementEadCode = element.eadCode;
            this.changedElementCurYear = element.curYear;
            this.changedElementRateRemainder = element.rateRemainder;
        }
        this.elementChangeModalVisible = true;
    }

    private saveElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot save data - loading already in progress');
            return;
        }

        const data: Dict.CivilPositionIncRate = {
            id: this.changedElementId,
            funcBlock: this.changedElementFuncBlock,
            level: this.changedElementLevel,
            activityField: this.changedElementActivityField,
            activityFieldExclusion: this.changedElementActivityFieldExclusion,
            begDate: this.changedElementBegDate,
            endDate: this.changedElementEndDate,
            rate: this.changedElementRate,
            form: this.changedElementForm,
            funcGr: this.changedElementFuncGr,
            eduHoursCode: this.changedElementEduHoursCode,
            eduOrgTypeCode: this.changedElementEduOrgTypeCode,
            eadCode: this.changedElementEadCode,
            curYear: this.changedElementCurYear,
            rateRemainder: this.changedElementRateRemainder,
        };
        if (data.begDate !== null) {
            data.begDate = (common.convertToKotlinLocalDate(data.begDate) as unknown as Date);
        }
        if (data.endDate !== null) {
            data.endDate = (common.convertToKotlinLocalDate(data.endDate) as unknown as Date);
        }


        const loadingId = Symbol('DictCivilPositionIncRatePage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        this.request<number>(
            {
                url: '/api/budget/staffing_table/dict/dict_civil_position_inc_rate',
                method: 'POST',
                data,
            },
            (data) => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataSaved(data),
                );
                this.changedElementId = data;
            },
            () => this.translates.errors.cannotSaveData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementChangeModalVisible = false;
                this.load();
            }
        );
    }
    // endregion


    // region Удаление элемента
    private elementDeletionModalVisible = false;
    private removedElementId: number = 0;

    private startElementDeletion(element: Dict.CivilPositionIncRate) {
        if (element.id === null) {
            console.error('Cannot delete element - ID is NULL');
            return;
        }

        this.removedElementId = (element.id as number);
        this.elementDeletionModalVisible = true;
    }

    private deleteElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot delete element - loading already in progress');
            return;
        }

        const id = this.removedElementId;

        const loadingId = Symbol('DictCivilPositionIncRatePage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/dict/dict_civil_position_inc_rate',
            [
                ['id', id],
            ],
        );

        this.request<unknown>(
            {
                url,
                method: 'DELETE',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataDeleted(id),
                );
            },
            () => this.translates.errors.cannotDeleteData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementDeletionModalVisible = false;
                this.load();
            }
        );
    }
    // endregion
}
